<template>
  <v-content app style="padding-top: 30px;background-color:whitesmoke">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </v-content>
</template>
<script>
// @vuese
// Body
// @group MainLayout
export default {};
</script>
